"use strict";

exports.__esModule = true;
exports.UpdateDeviceScreen = void 0;
var _react = _interopRequireWildcard(require("react"));
var _System = require("../../../System");
var _Core = require("../../Core");
var _DeviceCollection = require("../DeviceCollection");
var _DeviceDataItemsContext = require("../DeviceDataItemsContext");
var _DeviceEditor = require("../DeviceEditor");
var _App = require("../../App");
var _dec, _class, _UpdateDeviceScreen;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Screen which allows users to update existing device.
 */
var UpdateDeviceScreen = exports.UpdateDeviceScreen = (_dec = _DeviceCollection.DeviceCollectionContext.withContext, _dec(_class = (0, _Core.withTranslator)(_class = (_UpdateDeviceScreen = /*#__PURE__*/function (_Component) {
  function UpdateDeviceScreen() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.handleSubmit = function (device) {
      var _this$props = _this.props,
        deviceCollection = _this$props.deviceCollection,
        history = _this$props.history;
      deviceCollection.update(device).then(function () {
        history.push((0, _System.getScreenURL)("DeviceList"));
      });
    };
    return _this;
  }
  _inheritsLoose(UpdateDeviceScreen, _Component);
  var _proto = UpdateDeviceScreen.prototype;
  _proto.render = function render() {
    var _this2 = this;
    var _this$props2 = this.props,
      deviceCollection = _this$props2.deviceCollection,
      match = _this$props2.match,
      translator = _this$props2.translator;
    var id = match.params.id;
    var translate = translator.translate;
    var device = deviceCollection.optimisticRead(id);
    var body;
    if (!device) {
      body = /*#__PURE__*/_react["default"].createElement(_Core.UhOh, {
        error: new Error(translator.translate("UpdateDeviceScreen.error.noSuchDevice", "Unknown device {id}", {
          id: id
        }))
      });
    } else {
      body = /*#__PURE__*/_react["default"].createElement(_DeviceDataItemsContext.DeviceDataItemsLoader, {
        deviceUUID: device.uuid
      }, function (_ref) {
        var loaded = _ref.loaded,
          fetching = _ref.fetching,
          error = _ref.error,
          data = _ref.data;
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, fetching && /*#__PURE__*/_react["default"].createElement(_Core.Spinner, null), error && /*#__PURE__*/_react["default"].createElement(_Core.UhOh, {
          error: error,
          title: "Error loading data items"
        }), loaded && data && /*#__PURE__*/_react["default"].createElement(_DeviceDataItemsContext.DeviceDataItemsContext.Provider, {
          value: data
        }, /*#__PURE__*/_react["default"].createElement(_DeviceEditor.DeviceEditor, {
          device: device,
          onSubmit: _this2.handleSubmit
        })));
      });
    }
    return /*#__PURE__*/_react["default"].createElement(_Core.Screen, {
      title: translate("UpdateDeviceScreen.title", "Edit Device: {id}", {
        id: id
      })
    }, /*#__PURE__*/_react["default"].createElement(_App.AppNavbar, {
      title: translate("UpdateDeviceScreen.title", "Edit Device: {id}", {
        id: id
      })
    }), body);
  };
  return UpdateDeviceScreen;
}(_react.Component), _UpdateDeviceScreen.defaultProps = {
  deviceCollection: undefined,
  translator: undefined
}, _UpdateDeviceScreen)) || _class) || _class);